import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Remonte automatiquement en haut de la page à chaque changement d'URL.
 * Comportement standard d'une SPA (sinon React Router conserve la position de scroll).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}
